module.exports = __webpack_public_path__ + "img/sec-15-ebest.02e54dd9.svg";